// extracted by mini-css-extract-plugin
export default {"sidebarLink":"SideBarLink_sidebarLink__-Elcd","icon":"SideBarLink_icon__y7xHG"};